import { Table } from '@pm2/text-component';
import { usePostloadedModal } from '@ui/kit';
import { TranscriptIcon } from '@ui/kit/icons';
import { makeHtmlNodeToJsxPrinter, generateJsxKey, textNodeToJsxPrinter, printAST } from '@utils/ast';
import { useElementToolbarActions, UniversalContextMenuButton } from '@utils/component-framework';
import { lightbox } from './transcript-button.styles.js';
import { jsx } from 'react/jsx-runtime';

const htmlNodeToJsxPrinter = makeHtmlNodeToJsxPrinter({
  handleTag: (tag, data, context) => {
    switch (tag) {
      case "table":
        return /*#__PURE__*/jsx(Table, {
          bordered: true,
          responsive: true,
          alternative: false,
          hover: true,
          striped: true,
          children: data.children
        }, generateJsxKey(context));
      default:
        return undefined;
    }
  }
}, () => ({
  html: htmlNodeToJsxPrinter,
  text: textNodeToJsxPrinter
}));
function TranscriptButton(props) {
  const triggerModal = usePostloadedModal();
  const toolbarActions = useElementToolbarActions();
  const handleClick = () => {
    triggerModal(/*#__PURE__*/jsx("div", {
      className: lightbox,
      children: printAST(props.transcript, {
        html: htmlNodeToJsxPrinter,
        text: textNodeToJsxPrinter
      })
    }));
    if (props.onClick) {
      props.onClick?.();
    } else {
      toolbarActions.onClose?.();
    }
  };
  const label = (() => {
    switch (props.nodeType) {
      case "text-component":
      case "image-component":
      case "component-framework.image-hotspots":
        return "Tekst-udgave af billede";
      case "audio-component":
        return "Tekst-udgave af lyd";
      default:
        return "Åbn tekst-udgave";
    }
  })();
  return /*#__PURE__*/jsx(UniversalContextMenuButton, {
    as: "button",
    layout: props.layout,
    label: label,
    onClick: handleClick,
    icon: /*#__PURE__*/jsx(TranscriptIcon, {})
  });
}

export { TranscriptButton };
//# sourceMappingURL=transcript-button.js.map
